import { useMutation } from "@apollo/client/react";
import { useNavigate } from 'react-router-dom';
import { VALIDAR_CAMBIO_PROGRAMA } from '../../../data/graphQL/mutations/ResumenIngresoValidation/ValidarCambioPrograma';
import { toast } from 'react-hot-toast';

export const useGetActions = ({ handleChange, notification }) => {
  const navigate = useNavigate();

  const [validarCambioPrograma, { loading: validarLoading }] = useMutation(VALIDAR_CAMBIO_PROGRAMA, {
    fetchPolicy: 'no-cache',
    onCompleted: () => {
      toast.success("Se ejecuto la validación correctamente!");
    }
  });

  const handleClickValidar = (rechazo) => {
    validarCambioPrograma({
      variables: {
        input: {
          idEvaluacion: notification?.idEvaluacion,
          isApproval: !rechazo?.idMotivoRechazo,
          idMotivoRechazo: !!rechazo?.idMotivoRechazo ? rechazo?.idMotivoRechazo : null,
          observacion: !!rechazo?.observacion ? rechazo?.observacion : null
        }
      }
    }).then(() => {
      setTimeout(() => navigate('/asignacionValidacionResumenIngreso'), 1000);
    }).catch(() => toast.error('Ha ocurrido un error!'));;
  };

  return {
    handleClickValidar,
    loading: validarLoading
  };
};